// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__124p-","paymentContainer":"PaymentPage_paymentContainer__2Kz-s"};